module.exports = __webpack_public_path__ + "static/media/icons.4914bda1.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/trumbowyg/dist/ui/icons.svg
// module id = 1088
// module chunks = 58